import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import SingleFile from "./uploadType/SingleFile.jsx";
import BatchFile from "./uploadType/BatchFiles.jsx";
import { display } from "@mui/system";

export default function PdfTab() {

    const [value, setValue] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams()

    const handleChange = (event, newValue) => {
        // setSearchParams({ page: newValue })
        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            newParams.set('upload-type', newValue + 1)
            return newParams;
        })
        setValue(newValue);
    };

    useEffect(() => {
        const pageIndex = searchParams.get("upload-type")
        if (pageIndex !== null) {
            setValue(Number(pageIndex) - 1)
        }
    }, [searchParams])

    const tabPage = (index) => {
        switch (index) {
            case 0:
                return <SingleFile />
            case 1:
                // navigate("/location-analytics")
                return <BatchFile />
            default:
                return <SingleFile />;
        }
    }

    return (
        <div style={{
            height: '65vh', width: '100%', display: 'flex',
            flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
        }} >
            <div style={{
                display: 'flex', justifyContent: 'center',
                borderRadius: '10px',
                boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px", width: '75%', maxWidth: '450px'
            }} >
                <div style={{
                    padding: '0 1%', display: 'flex', flexDirection: 'column', width: '100%',
                    justifyContent: 'center', padding: '0 15px 30px 15px'
                }}>
                    <div style={{ width: '100%', padding: '0 1%', display: 'flex', flexDirection: 'column', alignItems: 'start', marginBottom: '5px' }}>
                        <div style={{ padding: '10px 5px' }}>
                            <p style={{ margin: 0, fontWeight: '600' }}>Upload files</p>
                        </div>
                        <Tabs value={value} onChange={handleChange} sx={{
                            minHeight: '38px',
                            '& .MuiButtonBase-root': {
                                padding: '4px 8px', // Reduced padding   
                                minHeight: '0'
                            },
                            '& .Mui-selected': {
                                color: 'black'
                            }
                        }}>
                            <Tab label="Single File" sx={{ textTransform: 'none', }} />
                            <Tab label="Batch Files" sx={{ textTransform: 'none' }} />
                        </Tabs>
                    </div>
                    {tabPage(value)}
                </div >
            </div>
        </div>
    )
}